import React, { useEffect, useState } from 'react';

import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { GraduationCapIcon } from 'lucide-react';
import { base_url } from '../../config';
import axios from 'axios';
import StudentProofModal from './StudentProofModal';

const UserTable = () => {
  const [data, setData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [pdf, setPDF] = useState(null);
  const [rowData, setRowData] = useState(null);


  const reloadData = async () => {
    try {
      const response = await axios.get(`${base_url}/api/admin/students`);
      setData(response.data);
    } catch (error) {
      console.error('Error fetching students:', error);
    }
  }
   

  
  useEffect(() => {
    reloadData();  
  }, []);

  const columns = [
    {
      accessorKey: 'code',
      header: 'Code',
    },
    {
      accessorKey: 'name',
      header: 'Name',
    },
    {
      accessorKey: 'type',
      header: 'Type',
    },
    {
      accessorKey: 'email',
      header: 'Email',
    },
    {
      accessorKey: 'volunteer',
      header: 'Volunteer',
    },
    {
      id: 'actions',
      header: 'Validate',
      Cell: ({ row }) => (
        <button
          onClick={() => handleAction(row.original)}
          style={{ padding: '6px 12px', border: '1px solid #ccc', borderRadius: '4px', background: '#f5f5f5', cursor: 'pointer' }}
        >
          Open
        </button>
      ),
    },
  ];

  const handleAction = async (row) => {
    
    const response = await axios
    .get(`${base_url}/api/admin/students_pdf`, {
      params: { id: row.student_proof_file_id }, 
      responseType: 'blob',
    })
    .then((response) => {
      // the response contains a PDF binary data
      const blob = new Blob([response.data], { type: 'application/pdf' });
      setPDF(blob);
      setRowData(row);
      setModalOpen(true);
    })
    .catch((error) => console.error('Error fetching student proof:', error));


    setModalOpen(true);
  };

  return <>
  
    <div className="text-2xl mt-4 pb-4 font-bold flex gap-8 items-center">
      <GraduationCapIcon />
      Student Validations
    </div>
 
    <div style={{ flex: '1 1 0', paddingBottom: '20px' }}>
      <MaterialReactTable columns={columns} data={data} />
    </div>
    <StudentProofModal
      isOpen={modalOpen}
      onClose={() => setModalOpen(false)}
      pdf={pdf}
      row={rowData}
      onAccept={reloadData}
      onDecline={reloadData}
    />
  </>;
};


export default UserTable;
